import { Moon, Sun } from 'lucide-react'

import { useThemeStore } from '../stores/themeStore'

/**
 * Toggle de tema light/dark — botón discreto pensado para el header.
 * Persistencia y anti-flash gestionados por themeStore + script en index.html.
 *
 * Ver Docs/18-BRAND.md §6.2.
 */
export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme)
  const toggle = useThemeStore((s) => s.toggle)

  const isDark = theme === 'dark'
  const label = isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="inline-flex h-9 w-9 items-center justify-center rounded-md
                 border border-line text-ink-muted
                 hover:border-line-strong hover:text-ink
                 focus:outline-none focus:ring-2 focus:ring-brand/40
                 transition-colors"
    >
      {isDark ? (
        <Sun className="h-4 w-4" strokeWidth={1.5} />
      ) : (
        <Moon className="h-4 w-4" strokeWidth={1.5} />
      )}
    </button>
  )
}
